window.Parsley = require('parsleyjs');

window.Parsley.addValidator('datetime', {
    requirementType: 'string',
    validateString: function(value, requirement, field) {
        let dateTime = value;

        if (
            dateTime.toLowerCase().indexOf('am') > -1 ||
            dateTime.toLowerCase().indexOf('pm')
        ) {
            dateTime = value.slice(0, -2).trim();
        }

        // capture all the parts
        var matches = dateTime.match(
            /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/,
        );

        //alt:
        // value.match(/^(\d{2}).(\d{2}).(\d{4}).(\d{2}).(\d{2}).(\d{2})$/);
        // also matches 22/05/2013 11:23:22 and 22a0592013,11@23a22
        if (matches === null) {
            return false;
            // invalid
        } else {
            // now lets check the date sanity
            var year = parseInt(matches[1], 10);
            var month = parseInt(matches[2], 10) - 1; // months are 0-11
            var day = parseInt(matches[3], 10);
            var hour = parseInt(matches[4], 10);
            var minute = parseInt(matches[5], 10);
            var date = new Date(year, month, day, hour, minute);
            if (
                date.getFullYear() !== year ||
                date.getMonth() != month ||
                date.getDate() !== day ||
                date.getHours() !== hour ||
                date.getMinutes() !== minute
            ) {
                return false;
            } else {
                return true;
            }
        }
    },
    messages: {
        en: 'Date format is not valid',
    },
});

window.Parsley.addValidator('greaterThan', {
    requirementType: 'number',
    validateNumber: function(value, requirement, field) {
        return value > requirement;
    },
    messages: {
        en: 'This value must be greater than %s',
    },
});

window.Parsley.addValidator('greaterOrEqual', {
    requirementType: 'number',
    validateNumber: function(value, requirement, field) {
        return value >= requirement;
    },
    messages: {
        en: 'Must be greater or equal to %s',
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/parsleyjs.js